import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor, NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';
import { Input } from '../../../Form/styles';
import { Button as BasicButton } from '../styles';

const ButtonsWrapper = styled('div')`
	display: flex;
	justify-content: space-between;
	margin-top: 30px;
`;

const Button = styled(BasicButton)`
	width: 100px;
	font-size: 15px;
	justify-content: center;

	&:disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	& + & {
		margin-left: 10px;
	}

	&:not(:last-of-type) {
		margin-bottom: 0;
	}
`;

interface PopupInputWrapperProps {
	isError: boolean;
}

const PopupBody = styled('div')`
	padding: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const PopupInputLabel = styled(Translate)`
	display: block;
	margin-bottom: 5px;
	font-size: 14px;
	line-height: 18px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const PopupInputWrapper = styled('div')`
	${Input} {
		border-color: transparent;
		background-color: ${hexToRgba(NewStyleColor.White, 10)};
		font-size: 16px;
		color: ${NewStyleColor.White};

		&:hover {
			border-color: ${({ isError }: PopupInputWrapperProps) => isError
				? StyleColor.LightRed
				: NewStyleColor.White
			};
		}
	}

	${({ isError }: PopupInputWrapperProps) => isError && `
		${Input} {
			border-color: ${StyleColor.LightRed};
		}

		${PopupInputLabel} {
			color: ${StyleColor.LightRed};
		}
	`}
`;

export {
	ButtonsWrapper,
	Button,
	PopupBody,
	PopupInputWrapper,
	PopupInputLabel,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/styles.ts